module.exports = __webpack_public_path__ + "img/53_52.b355af20.png";